import { GET_POOL_NAMES } from '../actions/types';

export default (state = null, action) => {
  switch (action.type) {
    case GET_POOL_NAMES:
      return action.payload;
    default:
      return state;
  }
};
